export interface SearchNotificationMailUserRequest {
  contactTypes: string[]
  userTypes: string[]
  userStatus: string[]
  addressCodeFrom: string
  addressCodeTo: string
  areaCodeFrom: string
  areaCodeTo: string
  lastLendDate: string
  expirationDate: string
}

export function SearchNotificationMailUserRequestToJSON(
  value: SearchNotificationMailUserRequest
): any {
  return {
    contact_types:
      value.contactTypes.length > 0 ? value.contactTypes : undefined,
    user_types: value.userTypes.length > 0 ? value.userTypes : undefined,
    user_status: value.userStatus.length > 0 ? value.userStatus : undefined,
    address_code_from:
      value.addressCodeFrom !== '' ? value.addressCodeFrom : undefined,
    address_code_to:
      value.addressCodeTo !== '' ? value.addressCodeTo : undefined,
    area_code_from: value.areaCodeFrom !== '' ? value.areaCodeFrom : undefined,
    area_code_to: value.areaCodeTo !== '' ? value.areaCodeTo : undefined,
    last_lend_date: value.lastLendDate !== '' ? value.lastLendDate : undefined,
    expiration_date:
      value.expirationDate !== '' ? value.expirationDate : undefined
  }
}
